import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { getAWSelectStyles } from './AWSelect.styles';
import React from 'react';

interface Option {
  label: string;
  value: string | number;
}

interface AWSelectProps {
  creatable?: boolean;
  options: Option[];
  value?: Option | Option[] | null;
  defaultValue?: Option | Option[];
  onChange: (value: any) => void;
  onBlur?: () => void;
  placeholder?: string;
  multi?: boolean;
  disabled?: boolean;
  clearable?: boolean;
  closeMenuOnSelect?: boolean;
  className?: string;
  name?: string;
  formatCreateLabel?: (inputValue: string) => string;
  menuPortalTarget?: null | HTMLElement;
  searchable?: boolean;
  dark?: boolean;
}

const AWSelect: React.FC<AWSelectProps> = ({
  creatable = false,
  options,
  value,
  defaultValue,
  onChange,
  onBlur,
  placeholder,
  multi = false,
  disabled = false,
  clearable = false,
  closeMenuOnSelect = true,
  className,
  name,
  formatCreateLabel,
  menuPortalTarget,
  searchable = true,
  dark =false,
}) => {

  const Component = creatable ? CreatableSelect : Select;

  return (
    <div className={`aw-input ${className ?? ''} ${dark ? 'dark-mode' : ''}`}>
      <Component
        classNamePrefix="custom-select"
        options={options}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        onBlur={onBlur}
        name={name}
        isClearable={clearable}
        placeholder={placeholder}
        isMulti={multi}
        isDisabled={disabled}
        isSearchable={searchable}
        closeMenuOnSelect={closeMenuOnSelect}
        formatCreateLabel={formatCreateLabel}
        menuPortalTarget={menuPortalTarget}
        styles={getAWSelectStyles(disabled, dark)}
      />
    </div>
  );
};

export default AWSelect;
